import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-sm text-gray-500" }
const _hoisted_4 = { class: "mt-2 text-gray-900" }
const _hoisted_5 = { class: "mt-4 grid grid-cols-2 md:grid-cols-5 gap-4" }
const _hoisted_6 = { class: "text-xs uppercase tracking-wide text-gray-500" }
const _hoisted_7 = { class: "overflow-x-auto py-2 -my-2 px-6 -mx-6" }
const _hoisted_8 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_9 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_10 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "text-sm text-red-600" }

import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import RowLink from '@/components/neue/RowLink.vue'
import SmartListLinks from '@/components/neue/SmartListLinks.vue'
import { failureReason, senderLabel, senderLink, statusBadge, statusTitle } from '@/helpers/messageLog'
import api from '@/store/api'


export default {
  __name: 'SentMessageDetail',
  setup(__props) {

const route = useRoute()
const loading = ref(true)
const blast = ref(null)
const entries = ref([])

const columns = [
  { width: 'minmax(150px, 1fr)' },
  { width: 'minmax(200px, 2fr)' },
  { width: '110px' },
  { width: 'minmax(200px, 2fr)' }
]

const sentAt = timestamp =>
  new Intl.DateTimeFormat([], {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(timestamp))

const stats = computed(() => {
  if (!blast.value) return []
  const attrs = blast.value.attributes
  return [
    { label: 'Recipients', value: attrs.recipients_count, classes: 'text-gray-900' },
    { label: 'Delivered', value: attrs.delivered_count, classes: 'text-green-800' },
    { label: 'Failed', value: attrs.failed_count, classes: attrs.failed_count ? 'text-red-600' : 'text-gray-900' },
    { label: 'Unsent', value: attrs.unsent_count, classes: 'text-gray-900' },
    { label: 'Pending', value: attrs.pending_count, classes: 'text-gray-900' }
  ]
})

const load = async () => {
  loading.value = true
  try {
    const res = await api.call('GET', `message_logs/${route.params.id}`, {}, { receive: false })
    blast.value = res.data.data || null
    entries.value = res.data.entries || []
  } catch (error) {
    blast.value = null
    entries.value = []
  } finally {
    loading.value = false
  }
}

onMounted(load)

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_TablistGrid = _resolveComponent("TablistGrid")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Sent message" })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            (blast.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_NeueWell, { class: "mb-8" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createTextVNode(" Sent " + _toDisplayString(sentAt(blast.value.attributes.created_at)) + " by ", 1),
                        _createVNode(RowLink, {
                          to: _unref(senderLink)(blast.value.attributes),
                          text: _unref(senderLabel)(blast.value.attributes)
                        }, null, 8, ["to", "text"]),
                        (blast.value.attributes.audiences?.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[0] || (_cache[0] = _createTextVNode(" to ", -1)),
                              _createVNode(SmartListLinks, {
                                lists: blast.value.attributes.audiences
                              }, null, 8, ["lists"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(blast.value.attributes.body), 1),
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value, (stat) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: stat.label
                          }, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(stat.label), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-lg font-bold", stat.classes])
                            }, _toDisplayString(stat.value), 3)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_TablistGrid, {
                              columns: columns,
                              header: ""
                            }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("div", null, "Timestamp", -1),
                                _createElementVNode("div", null, "To", -1),
                                _createElementVNode("div", null, "Status", -1),
                                _createElementVNode("div", null, "Error", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value, (entry) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            key: entry.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TablistGrid, { columns: columns }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(sentAt(entry.attributes.created_at)), 1),
                                  _createElementVNode("div", _hoisted_9, [
                                    _createTextVNode(_toDisplayString(entry.attributes.to_name || entry.attributes.to_phone) + " ", 1),
                                    (entry.attributes.to_name && entry.attributes.to_phone)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(entry.attributes.to_phone), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([
                          _unref(statusBadge)(entry.attributes.status).classes,
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full'
                        ]),
                                      title: _unref(statusTitle)(entry.attributes)
                                    }, _toDisplayString(_unref(statusBadge)(entry.attributes.status).label), 11, _hoisted_11)
                                  ]),
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(failureReason)(entry.attributes)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_NeueWell, {
                  key: 1,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EmptyState, {
                      plural: "sent messages",
                      description: "This sent message could not be found."
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}